import { createContext } from 'react'

const AuthGuestContext = createContext()

export default AuthGuestContext
